<template>
  <div v-if="value" class="delivery-log" :class="['delivery-log--theme-' + theme]">
    <template v-if="['click'].includes(event.event)">
      <FontAwesomeIcon :icon="['fas', 'check-circle']" class="text--success" />
      <span class="delivery-log__label">{{ $t('deliveryLogClickLabel', { resource }) }}</span>
    </template>

    <template v-else-if="['open'].includes(event.event)">
      <FontAwesomeIcon :icon="['fal', 'envelope-open']" />
      <span class="delivery-log__label">{{ $t('deliveryLogOpenLabel', { resource }) }}</span>
    </template>
    <template v-else-if="['bounce', 'dropped', 'blocked'].includes(event.event)">
      <FontAwesomeIcon :icon="['fas', 'times-circle']" class="text--error" />
      <span class="delivery-log__label">{{ $t('deliveryLogFailedLabel', { resource }) }}</span>
    </template>
    <template v-else-if="['delivered'].includes(event.event)">
      <FontAwesomeIcon :icon="['fal', 'envelope']" />
      <span class="delivery-log__label">{{ $t('deliveryLogDeliveredLabel', { resource }) }}</span>
    </template>

    <template v-else>
      <FontAwesomeIcon :icon="['fal', 'hourglass-start']" />
      <span class="delivery-log__label">{{ $t('deliveryLogUnknownLabel', { resource }) }}</span>
    </template>
    <span class="delivery-log__date">{{ event.date || value.date || new Date() | Moment('DD.MM.YY - HH:mm') }}</span>
    <div v-if="$path('receivers.length', value)" class="delivery-log__receivers">
      <span>{{ $tc('receiver', 2) }}: {{ value.receivers.join(', ') }}</span>
    </div>
  </div>
</template>

<script>
// processed, deferred, delivered, open, click, bounce, dropped, spamreport, unsubscribe, group_unsubscribe, group_resubscribe
import { Moment } from '@/filters'

export default {
  props: {
    value: Object,
    theme: {
      type: String,
      enum: ['default', 'pill'],
      default: 'default',
    },
    resource: String,
  },
  computed: {
    events() {
      return this.value.events.sort(({ date: a }, { date: b }) => new Date(b).getTime() - new Date(a).getTime())
    },
    event() {
      return (
        this.events.find(e => ['click'].includes(e.event)) ||
        this.events.find(e => ['open'].includes(e.event)) ||
        this.events.find(e => ['bounce', 'dropped', 'blocked'].includes(e.event)) ||
        this.events.find(e => ['delivered'].includes(e.event)) ||
        this.events.find(e => ['processed', 'deferred'].includes(e.event)) ||
        {}
      )
    },
    message() {
      return this.data
    },
  },
  filters: {
    Moment,
  },
}
</script>

<style lang="scss">
.delivery-log {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-wrap: wrap;
  font-size: 0.7em;

  span {
    opacity: 0.75;
    order: 1;
  }

  svg {
    order: 2;
    margin-left: 3px;
  }

  &__date {
    font-style: italic;
  }
  &__receivers {
    order: 2;
    font-style: italic;
  }
  &--theme-pill {
    padding: 5px 10px;
    border: 1px solid var(--border-color);
    border-radius: 20px;
  }
}
</style>
